import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

const PRINT_WITH_EXPLANATIONS_AND_NOTICE_PREFERENCE_KEY =
   'printEntitlementStatementsWithExplanationsAndNoticePreference';

type UsePrintWithExplanationsAndNoticePreferenceReturnFn = {
   printWithExplanationsAndNoticePreference: boolean;
   handleSetPrintWithExplanationsAndNoticePreference: (preference: boolean) => void;
};

export const usePrintWithExplanationsAndNoticePreference = (): UsePrintWithExplanationsAndNoticePreferenceReturnFn => {
   const [
      printWithExplanationsAndNoticePreference,
      setPrintWithExplanationsAndNoticePreference,
   ] = useLocalStorage<boolean>(PRINT_WITH_EXPLANATIONS_AND_NOTICE_PREFERENCE_KEY, false);

   const handleSetPrintWithExplanationsAndNoticePreference = useCallback(
      (printWithExplanationsAndNotice: boolean) => {
         setPrintWithExplanationsAndNoticePreference(printWithExplanationsAndNotice);
      },
      [setPrintWithExplanationsAndNoticePreference]
   );

   return {
      printWithExplanationsAndNoticePreference: printWithExplanationsAndNoticePreference ?? false,
      handleSetPrintWithExplanationsAndNoticePreference: handleSetPrintWithExplanationsAndNoticePreference,
   };
};
